export const BTN_PRIMARY = 'BTN_PRIMARY';
export const BTN_SECONDARY = 'BTN_SECONDARY';
export const GREY_BUTTON = 'GREY_BUTTON';
